import React, { useEffect, useRef, useState } from "react";
import "./TaskAssigned.css"
import Header from "../../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../../Components/Dashboard/Sidebar/Sidebar";
import FloatingLabelInput from "../../../../Components/floatingLabel/FloatingLabel";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import { GetToken, RemoveUserSession } from "../../../../Utils/utils";
import axios from "axios";
import Select from "react-select";
import Loader from "../../../../Components/loader/loader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const TaskAssigned = () => {
  const navigate = useNavigate();
  const LoginToken = GetToken();
  const [dummy, setDummy] = useState(false);
  const fileInputRef = useRef(null);
  const [showSidebar, setShowSidebar] = useState(true);
  const [loading, setLoading] = useState(false);
  const [fileDocument, setFileDocument] = useState(null);
  const [profileAlldata, setProfileAllData] = useState({
    title: "",
    description: "",
    projectGetId: "",
    reportToIdGet: "",
    assignedUserId: "",
  });
console.log(profileAlldata,"profileAlldata");
  const [projectId, setProjectId] = useState([]);

  const [getAllUser, setGetAllUser] = useState([]);

  // validation fields 
  const [errorTitle, setErrorTitle] = useState();
  const [ErrorDescription, setErrorDescription] = useState();

  const validate = () => {
    if (!profileAlldata?.title) {
      setErrorTitle("userTitle");
      return false;
    }
    if (!profileAlldata?.description) {
      setErrorDescription("userDescription");
      return false;
    }
    return true;
  };

  // GET API'S 
  const GetAllProjects = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `https://attendanceapi.elitewebdemo.com/api/Projects/GetAllProjects`,
    };
    axios(option)
      .then((e) => {

        const data = JSON.parse(e?.data?.data);
        // return
        const ProjectId = data?.map((item) => ({
          // label: item?.ProjectId,
          // value: item?.ProjectId,
          label: item?.ProjectName,
          value: item?.ProjectId,


        }));
        setProjectId(ProjectId)

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);

        // if (
        //   error?.message === "Network Error" &&
        //   error?.code === "ERR_NETWORK"
        // ) {
        //   toast.error("Your Session has been expired");
        //   RemoveUserSession();
        //   navigate("/");
        // }
      });
  };

  const GetAllUser = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `https://attendanceapi.elitewebdemo.com/api/Recas/GetAllUsers`,
    };
    axios(option)
      .then((e) => {
        const allData = JSON.parse(e?.data?.data)

        const ReportId = allData?.Result;
        const ReportTold = ReportId?.map((item) => ({
          label: item,
          value: item,
        }));

        setGetAllUser(ReportTold);

      })
      .catch(() => { });
  };
  useEffect(() => {
    GetAllProjects();
    GetAllUser();
  }, []);


  const handleCancel = (e) => {
    setProfileAllData({
      title: "",
      description: "",
      projectGetId: "",
      reportToIdGet: "",
      assignedUserId: "",
    });
    setFileDocument (" ") 
    fileInputRef.current = null;

  }
  
  const handleTaskAssign = () => {
    if (!validate()) return;
    const formData = new FormData();
    formData.append("Title", profileAlldata.title);
    formData.append("Description", profileAlldata.description);
    formData.append("ProjectId", profileAlldata.projectGetId);
    formData.append("ReportToId", profileAlldata.reportToIdGet);
    profileAlldata.assignedUserId.forEach(id => {
      formData.append("AssignedUserIds", JSON.stringify(id));
  });    formData.append("AttachmentDocumnet", fileDocument);


    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        // "access-control-allow-origin": "*",
        // "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },  
      url: `https://attendanceapi.elitewebdemo.com/api/Task/AssignTask`,
      data: formData,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
        }
        setProfileAllData({
          title: "",
          description: "",
          projectGetId: "",
          reportToIdGet: "",
          assignedUserId: "",
        });
        setFileDocument (" ") 
        fileInputRef.current = null;
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);


  const handleAttachImageChange = (e) => {
    const file = e.target.files[0];
    setFileDocument(file);
  };  

  return (
    <>
      {loading ? <Loader /> : null}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">  
        <Sidebar showSidebar={showSidebar} dummy={dummy} setDummy={setDummy} />
        <section
          className={
            showSidebar
              ? "EMP-profile-main-section"
              : "EMP-profile-main-section-new"
          }
        >
          <div className="EMP-profile-all-icons">
            <div>
              <p className="MAIN-HEADING">Task </p>
            </div>
            <div className="dashboiard-inner-header">
              <BiHomeAlt className="EMP-home-icon-header-inn" />
              <MdKeyboardArrowRight />
              <p> Task </p>
              <MdKeyboardArrowRight />
              <p> Assign </p>
            </div>
          </div>
          <div className="EMP-profile-main-container">
            <div className="EMP-profile-outter-container">
              <div className="EMP-profile-inner-container">
                <div className="EMP-profile-heading">
                  <p> Task</p>
                </div>
                <div className="EMP-profile-inner-box row">
                  {/* Name Field   */}
                  <div className="profile-inputs col-6">
                    <FloatingLabelInput
                      label="Title*"
                      value={profileAlldata?.title}
                      onChange={(e) =>
                        setProfileAllData({
                          ...profileAlldata,
                          title: e?.target?.value,
                        })
                      }
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorTitle("userTitle");
                        } else {
                          setErrorTitle("false");
                        }
                      }}
                    />
                    {errorTitle === "userTitle" &&
                      !profileAlldata?.title ? (
                      <span className="contact_error-dob">
                        Title is required.
                      </span>
                    ) : null}
                  </div>

                  {/* Discription Field  */}
                  <div className="profile-inputs col-6">
                    <FloatingLabelInput
                      label="Description*"
                      value={profileAlldata?.description}
                      onChange={(e) =>
                        setProfileAllData({
                          ...profileAlldata,
                          description: e?.target?.value,
                        })
                      }
                      style={{ marginBottom: 0 }}
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorDescription("userDescription");
                        } else {
                          setErrorDescription("false");
                        }
                      }}
                    />
                    {ErrorDescription === "userDescription" && !profileAlldata?.description ? (
                      <span className="contact_error-dob">
                        Description is required.
                      </span>
                    ) : null}
                  </div>
                  {/* project id  */}
                  <div className="TaskAssigend-foruser col-6">
                    <label htmlFor="">Project </label>
                    <Select
                      classNamePrefix="Project-ID-drop-down"
value={profileAlldata?.projectGetId ? projectId?.find(project => project.value === profileAlldata.projectGetId) : null}
// value={profileAlldata?.projectGetId ? { value: profileAlldata?.projectGetId, label: projectId?.value } : null}
                      options={projectId}
                      getOptionLabel={(options) => options?.label}
                      getOptionValue={(options) => options?.value}
                      onChange={(e) =>
                        setProfileAllData({
                          ...profileAlldata,
                          projectGetId: e?.value,
                        })}
                    />
                  </div>

                  <div className="TaskAssignedd-file col-6">
                    <label htmlFor="">Report To </label>
                    <Select
                      classNamePrefix="taskAssigned-dropdown"
                      // value={profileAlldata?.reportToIdGet ? { value: profileAlldata?.reportToIdGet, label: profileAlldata?.reportToIdGet } : null}
                      value={profileAlldata?.reportToIdGet ? getAllUser?.find(project => project.value === profileAlldata.reportToIdGet) : null}

                      options={getAllUser}
                      getOptionLabel={(options) => options?.label?.UserName}
                      getOptionValue={(options) => options?.value?.Id}
                      onChange={(e) =>
                        setProfileAllData({
                          ...profileAlldata,
                          reportToIdGet: e?.value?.Id,
                        })}
                    />
                  </div>

                  <div className="TaskAssigend-foruser col-6">

                    <label htmlFor="">Assigned User </label>
                    {/* <Select
                      classNamePrefix="Assigned-user-id"
                      isMulti
                      value={profileAlldata?.assignedUserId ? { value: profileAlldata?.assignedUserId, label: profileAlldata?.assignedUserId } : null}
                      options={getAllUser}
                      getOptionLabel={(options) => options?.label?.UserName}
                      getOptionValue={(options) => options?.value?.UserName}
                      onChange={(selectedOptions) => {

                        const selectedIds = selectedOptions.map(option => option.value.Id);
                        setProfileAllData({
                          ...profileAlldata,
                          assignedUserId: selectedIds,
                        });
                      }}
                    /> */}
<Select
    classNamePrefix="Assigned-user-id"
    isMulti
    value={profileAlldata?.assignedUserId 
        ? getAllUser.filter(user => profileAlldata.assignedUserId.includes(user.value.Id)) 
        : []
    }
    options={getAllUser.filter(user => !profileAlldata?.assignedUserId || !profileAlldata.assignedUserId.includes(user.value.Id))}
    getOptionLabel={(option) => option?.label?.UserName}
    getOptionValue={(option) => option?.value?.Id}
    onChange={(selectedOptions) => {
        const selectedIds = selectedOptions?.map(option => option.value.Id);
        setProfileAllData({
            ...profileAlldata,
            assignedUserId: selectedIds,
        });
    }}
/>

                  </div>
                  <div className="TaskAssignedd-file col-6">
                    <label htmlFor="">Attachment Documnet</label>
                    <div className="profile-inputs-for-image-inner-div">
                      <input
                        type="file"
                        id="profileImage"
                        ref={fileInputRef}
                        onChange={handleAttachImageChange}
                      />
                    </div>
                  </div>

                  {/* <div className="profile-inputs-for-image col-6">
                    <label htmlFor="profileImage">AttachmentDocumnet</label>
                    <div className="profile-inputs-for-image-inner-div">
                      <input
                        type="file"
                        id="profileImage"
                        ref={fileInputRef}
                        onChange={handleImageChange}
                      />

                    </div>
                  </div> */}

                  <div className="Addemployee-buttons">

                    <button
                      className="Profile-submit-button"
                      onClick={() => handleTaskAssign("update")}>
                      Submit
                    </button>
                    <button className="Profile-Cancel-button"
                      onClick={() => handleCancel()}
                    > Cancel </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default TaskAssigned;
